
import React, { useState, useEffect } from 'react';

import { Tag, Flex } from 'antd-mobile';
import moment from 'moment';

import * as Api from "../../../api/usms";
import { Error, Loading, TitleDescriptions } from '../components';
// import RiskInfo from './RiskInfo';

import { UpgradeStatue } from '../../../utils/const';
import { showWithTimeZone } from '../../../utils/timeFormat';

function CompanyInfo(props) {

  const { CompanyId } = props;

  const [info, setInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (CompanyId) {
      getInfo(CompanyId);
    }
  }, [CompanyId])

  const getInfo = (CompanyId) => {
    const data = {
      CompanyIds: [+CompanyId],
    }
    setLoading(true);
    Api.GetCompanyList(data).then(res => {
      if (res.Data) {
        setInfo(res.Data[0] || {});
      } else {
        setErrorMessage("获取公司信息失败，项目ID：" + CompanyId)
      }
      setLoading(false);
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });
  }
  return (
    <Loading loading={loading} >
      {errorMessage ?
        <Error message={errorMessage} /> :
        <TitleDescriptions
          title={<div>
            {info.CompanyName || info.Email || '(无公司名称)'}
            {info.DisplayName ? ` (${info.DisplayName})` : null}
            {/* <span>
              {info.IndustryTagId ? (
                <Tag color="geekblue">{getFieldConfigNameById(FieldConfigType.industry, info.IndustryTagId)}</Tag>
              ) : null}
            </span> */}
            {/* 升级状态 */}
            <Tag style={{ marginLeft: '12px' }} selected={info.Upgrade === 1}>
              {UpgradeStatue[info.Upgrade === 1 ? 'Enable' : 'Disable'] || '-'}
            </Tag>
          </div>}
          descriptions={[<div>
            <div>
              <Flex direction='column' justify='start'>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>
                    公司ID：
                    {`${info.CompanyId}`}
                  </span>
                  <span style={{ marginLeft: '16px' }}>邮箱：{info.Email || '-'}</span>
                </Flex.Item>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>注册地：{info.RegistrationCountry || '-'}</span>
                  <span style={{ marginLeft: '16px' }}>
                    注册时间：{moment(info.RegistrationTime * 1000).format('YYYY-MM-DD') || '-'}
                  </span>
                </Flex.Item>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>手机：{info.Phone || '-'}</span>
                  <span style={{ marginLeft: '16px' }}>时区：{info.Timezone || '-'}</span>
                </Flex.Item>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>
                    客户时间：{showWithTimeZone(moment().unix(), info.Timezone).formatWithNoUTC || '-'}
                  </span>
                  <span style={{ marginLeft: '16px' }}>渠道码：{info.ChannelCode || '-'}</span>
                </Flex.Item>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>销售码：{info.SaleCode || '-'}</span>
                  <span style={{ marginLeft: '16px' }}>备注：{info.Remark || '-'}</span>
                </Flex.Item>
                <Flex.Item wrap='nowrap' style={{ width: '100%' }}>
                  <span>销售人员：{info.SalespersonName || '-'}</span>
                </Flex.Item>
              </Flex>
            </div>
          </div>]} />
      }
    </Loading>
  )
}

export default CompanyInfo